export default {
  cloneFromType: {
    survey: '調査',
    template: 'テンプレート',
  },
  createSurvey: '調査を作成',
  createTemplate: 'テンプレートを作成',
  newSurvey: '新規調査',
  newSurveyFromScratch: '新規調査を最初から作成',
  newTemplate: '新規テンプレート',
  newTemplateFromScratch: '新規テンプレートを最初から作成',
  source: {
    label: 'ソース',
    arena: 'Arena（.zip）',
    collect: 'Collect（.collect、.collect-backup、.collect-data）',
    odk: 'ODK (.xml)',
  },
  startImport: 'インポートを開始',
  survey: '調査',
  survey_other: '調査',
  template: 'テンプレート',
  template_other: 'テンプレート',
  error: '新規調査の作成中にエラーが発生しました',
  errorMaxSurveysCountExceeded: `調査の作成中にエラーが発生しました。作成可能な調査数の上限（{{maxSurveysCount}}件）に達しています。`,
  options: {
    includeData: 'データを含める',
  },
}
